import * as yup from 'yup';

import * as MESSAGES from '../messages';

export const blogSchema = yup.object().shape({
  title: yup.string().min(5, MESSAGES.BLOG_SHORT_TITLE_MESSAGE),
  descriptionText: yup.string().min(20, MESSAGES.BLOG_SHORT_DESCRIPTION_MESSAGE),
});
